export default "__VITE_ASSET__930b95e1__"